module.exports = function() {
    return function(input) {

        var val = typeof input == 'number' && !isNaN(input) && isFinite(input) ?  Math.round(input) : 0;

        return val + '%';
    };
};